module.exports = __webpack_public_path__ + "/images/ico-cover-invitacion-success.0b54c40.svg";